import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/gitex_thumb_2025.png"

export function Index() {
  return (
    <Layout
      title="How GITEX Global 2025 Activated the Full Event Lifecycle with Premagic"
      description="GITEX Global 2025, held from October 6th to 10th at the Dubai World Trade Centre, brought together over 200,000 attendees and 6,000 exhibitors from around the world, making it the largest tech show on the planet."
      metaImage={ThumbnailImage}
      keywords={[
        "GITEX Global case study, Dubai tech conference, world largest tech event, Middle East technology summit, Dubai innovation showcase, Gulf tech conference, Arab world tech events, GITEX Dubai photos, tech expo networking, international tech summit, UAE technology events, Dubai startup showcase, Middle East innovation hub, global tech gathering, Dubai tech ecosystem",
      ]}
      noIndex
    >
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.OPENTEXT_PREMAGIC} />
    </Layout>
  )
}

export default Index
